import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('PageFooter', slot);
}

export const pageFooterClasses = generateUtilityClasses('PageFooter', [
  'root',
  'content',
  'button',
]);
